import { render, staticRenderFns } from "./boxed.vue?vue&type=template&id=fa37f560&scoped=true"
import script from "./boxed.vue?vue&type=script&lang=js"
export * from "./boxed.vue?vue&type=script&lang=js"
import style0 from "./boxed.vue?vue&type=style&index=0&id=fa37f560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa37f560",
  null
  
)

export default component.exports